// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 814) return "static/chunks/814-01a04600650da42c.js";
	if (chunkId === 3524) return "static/chunks/2170a4aa-0e5dabf640e8a8d0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4960":"19ab344822e1e8dd","7714":"1b8829c2516817fe","9039":"72a7a326280884d6"}[chunkId] + ".js";
};